import  React from 'react'
import styled from 'styled-components'
import { graphql, StaticQuery } from 'gatsby'
import BackgroundImage from 'gatsby-background-image'
import Criando from '../Criando'
import Button from '../button'

const Inner = styled.div`
  grid-area: banner;
  display: flex;
  padding-top: 70px;
  margin-top: 60px;
  justify-content: center;
  
  @media (min-width: 650px){
    margin-top: 96px;
    justify-content: space-between;
    margin-bottom: -5px;
  }

  @media (max-width: 768px){
    flex-direction: column;
    align-items: center;
    padding-top: 133px;
  }
`

const Text = styled.h1`
  color: #FFF;
  font-weight: 700;
  font-size: 2em;
  line-height: 53px;
  margin-bottom: 1.45rem;
  text-align: center;
  @media (min-width: 650px){
    text-align: left;
  }
`
const Paragraph = styled.p`
  color: #FFF;
  margin-bottom: 1.5em;
  font-size: 0.84em;
  text-align: center;
  @media (min-width: 650px){
    text-align: left;
  }
`

const TextGroup = styled.div`
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: 650px){
    align-items: flex-start;
  }

  @media (max-width: 768px){
    margin-bottom: 60px;
  }
  
`
// const Mark = styled.strong`
//   font-weight: 600;
// `

const BackgroundSection = ({ className }) => (
    <StaticQuery query={graphql`
      query {
        desktop: file(relativePath: { eq: "bg.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1920, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        mobile: file(relativePath: { eq: "bg_banner_mobile.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 702, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }

      }
    `}
     render={data => {
      const sources = [
        data.mobile.childImageSharp.fluid,
        {
          ...data.desktop.childImageSharp.fluid,
          media: `(min-width: 920px)`,
        },
      ]

       return (
          <BackgroundImage Tag="section"
                           className={className}
                           fluid={sources}
          >
            <Inner>
              <TextGroup>
                <Text>Integrações para Decolar seu Negócio</Text>
                <Paragraph>Facilite o seu trabalho conectando <br/>sua empresa com integrações.</Paragraph>
                <Button anchor="#integracoes" size="sm">Saiba Mais</Button>
              </TextGroup>
              <Criando />
            </Inner>
          </BackgroundImage>
       )
     }
     }
    />
)

const StyledBackgroundSection = styled(BackgroundSection)`
  width: 100%;
  min-height: 600px;
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;
  display: grid;
  margin-top: -153px;

  grid-template-areas: "banner";
  grid-template-columns: 1fr;
  grid-gap: 20px;
  padding: 0 30px;
  @media (min-width: 1140px){
    grid-template-columns: 1fr 1100px 1fr;
    grid-template-areas: ". banner .";
    padding: 0 ;
    margin-top: -97px;
  }

  /* &:before{
    @media (max-width: 768px){
      background-position-x: -620px !important;
    }

    @media (max-width: 528px){
      background-position-x: -480px !important;
    }
    @media (max-width: 416px){
      background-position-x: -458px !important;
    }
    

    
  } */


`

export default StyledBackgroundSection